module.exports = __webpack_public_path__ + "img/bg_question_des_1.7a92b601.jpg";